var AIMessageInput = React.createClass({
    getInitialState: function () {
        return {
            firstRequest: false, inputText: '',
            conversationId: '', isLoading: false,
            followupQuestions: [], contextCleared: false,
            sameRequestCount: 0,
            wordDict: Config.aiChatTriggerList,
            gptCurrentRequestId: 0
        };
    },

    componentDidMount: function () {
        if (RA.KBSearch.query.querytext && RA.KBSearch.query.querytext.length > 0) {
            let sessionGenAIResponse = JSON.parse(sessionStorage.getItem("genAIResponse"));
            if (sessionGenAIResponse && sessionGenAIResponse.length) {
                if (sessionGenAIResponse[0].requestText !== RA.KBSearch.query.querytext) {
                    sessionStorage.removeItem("genAIResponse");
                    this.setState({
                        firstRequest: true,
                        inputText: RA.KBSearch.query.querytext,
                        followupQuestions: []
                    }, () => {
                        this.handleSubmit();
                    });
                } else {
                    let lastMsg = sessionGenAIResponse.slice(-1)[0]
                    if (lastMsg.details.followupQuestions && lastMsg.details.followupQuestions.length) {
                        this.setState({ followupQuestions: lastMsg.details.followupQuestions })
                    }

                    this.setState({
                        contextCleared: lastMsg.contextCleared,
                        conversationId: lastMsg.conversationId
                    });
                    this.props.setIsInterrogativeFirstRequestGpt(lastMsg.isInterrogativeOrRequest);
                }
            } else {
                this.setState({ firstRequest: true, inputText: RA.KBSearch.query.querytext }, () => {
                    this.handleSubmit();
                });
            }
        }

        // Add 'keyup' event listener to input elements
        const inputElements = document.getElementsByClassName("main-search__input");
        for (const element of inputElements) {
            element.addEventListener('keyup', this.handleSearchInputChange);
        }

        // Add 'click' event listener to button elements
        const buttonElements = document.getElementsByClassName("main-search__button");
        for (const element of buttonElements) {
            element.addEventListener('click', this.handleSearchButtonClick);
        }

    },

    componentDidUpdate() {
        if (RA.KBSearch.isFilterApplied() && RA.KBSearch.filterApplied) {
            this.handleSubmitValidation()
        }
    },

    componentWillUnmount() {
        // Remove 'keyup' event listener from input elements
        const inputElements = document.getElementsByClassName("main-search__input");
        for (const element of inputElements) {
            element.removeEventListener('keyup', this.handleSearchInputChange);
        }

        // Remove 'click' event listener from button elements
        const buttonElements = document.getElementsByClassName("main-search__button");
        for (const element of buttonElements) {
            element.removeEventListener('click', this.handleSearchButtonClick);
        }

        if (this.currentController) {
            this.currentController.abort();
        }
    },

    handleSubmitValidation() {
        let sessionGenAIResponse = JSON.parse(sessionStorage.getItem("genAIResponse"));
        let $queryInput = $(".main-search__input");
        if (sessionGenAIResponse && sessionGenAIResponse.length) {
            if (sessionGenAIResponse[0].requestText === $queryInput.val()) {
                if (this.state.sameRequestCount >= 10 || RA.KBSearch.filterApplied) {
                    this.setState({
                        sameRequestCount: 0,
                        firstRequest: true,
                        inputText: $queryInput.val(),
                        followupQuestions: []
                    }, () => {
                        this.handleSubmit();
                    });
                    this.props.onSearchChanged();
                } else {
                    this.setState({ sameRequestCount: this.state.sameRequestCount += 1 });
                }
            } else {
                this.setState({
                    sameRequestCount: 0,
                    firstRequest: true,
                    inputText: $queryInput.val(),
                    followupQuestions: []
                }, () => {
                    this.handleSubmit();
                });
                this.props.onSearchChanged();
            }
        }
    },

    handleSearchInputChange: function (event) {
        let $queryInput = $(".main-search__input");
        if ($queryInput.val().trim() !== "" && event.key === 'Enter') {
            this.handleSubmitValidation()
        }
    },

    handleSearchButtonClick(event) {
        let $queryInput = $(".main-search__input");
        if ($queryInput.val().trim() !== "" && event.pointerType === "mouse") {
            this.handleSubmitValidation()
        }
    },

    handleInputChange: function (event) {
        this.setState({ inputText: event.target.value });
    },

    sendFollowUpQuestion: function (followupQuestion) {
        this.setState({ inputText: followupQuestion }, () => {
            this.handleSubmit();
        });
    },

    handleSubmit: function () {
        RA.KBSearch.filterApplied = false;
        let self = this;

        const requestId = self.state.gptCurrentRequestId + 1;
        self.setState({ gptCurrentRequestId: requestId });

        if (self.currentController) {
            self.currentController.abort();
        }

        self.currentController = new AbortController();
        const { signal } = self.currentController;

        self.setState({ isLoading: true });

        let tempInputText = self.state.inputText;
        let url = `${Config.contextPath}/controller/services/gpt?action=chat`;
        let data = {
            conversationId: self.state.firstRequest ? '' : self.state.conversationId,
            text: self.state.inputText,
            query: RA.KBSearch.query
        };

        var headers = new Headers();
        headers.append('SToken', Config.csrf.value);


        if (!self.state.firstRequest) {
            self.props.onUserMessage(self.state.inputText);
        }

        if (self.state.wordDict.length === 1 && self.state.wordDict[0] === "*") {
            self.props.setIsInterrogativeFirstRequestGpt(true);
        } else {
            const MIN_WORDS_PATTERN = /\b\w+\b\s+\b\w+\b/;
            const chatTriggerList = self.state.wordDict.map(word => word.toLowerCase());
            const regex = new RegExp(`\\b(${chatTriggerList.join("|")})\\b`, "i");

            const text = self.state.inputText.toLowerCase();
            const isMatch = regex.test(text) && MIN_WORDS_PATTERN.test(text);

            if (isMatch) {
                self.props.setIsInterrogativeFirstRequestGpt(true);
            }
        }

        self.setState({ inputText: '' });
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data),
            signal,
        })
            .then(response => response.json())
            .then(res => {
                if (self.state.firstRequest && !res.response.isInterrogativeOrRequest) {
                    self.props.setIsInterrogativeFirstRequestGpt(res.response.isInterrogativeOrRequest);
                } else {
                    self.props.setIsInterrogativeFirstRequestGpt(true);
                    self.setState({ firstRequest: false });
                    if (res.code === 200) {
                        self.setState({ conversationId: res.response.conversationId });
                        self.setState({ followupQuestions: res.response.message.followupQuestions });
                        self.setState({ contextCleared: res.response.contextCleared });
                    }
                }
                if (res.code === 200) {
                    res.response.requestText = tempInputText;
                    self.props.onBotResponse(res.response);
                }
            })
            .catch(error => {
                console.error('Error sending or receiving messages:', error);
            })
            .finally(() => {
                if (self.state.gptCurrentRequestId === requestId) {
                    self.setState({ isLoading: false });
                }
            });
    },

    getLinkedTermsUrl: () => {
        const aiAnswerGenerationUrl = RA.KBSearch.getAiAnswerGenerationUrl();
        if (aiAnswerGenerationUrl && aiAnswerGenerationUrl.includes("openai")) {
            return "https://help.uplandsoftware.com/disclaimers/openai.htm";
        }

        return "https://help.uplandsoftware.com/disclaimers/upland.htm";
    },

    render: function () {
        return (
            this.state.isLoading ? (
                <div className="typing-indicator">
                    <div className="typing-indicator-dot"></div>
                    <div className="typing-indicator-dot"></div>
                    <div className="typing-indicator-dot"></div>
                </div>
            ) : (
                <div className="ai-chat-message-input">
                    {this.state.followupQuestions && this.state.followupQuestions.length > 0 &&
                        <div className="suggestion-container">
                            {this.state.followupQuestions.map((followupQuestion, index) => (
                                <div key={index}
                                    className="ai-chat-suggestion" style={{ cursor: 'pointer' }}
                                    onClick={() => this.sendFollowUpQuestion(followupQuestion)}>
                                    <div>
                                        <span className="glyphicon glyphicon-question-sign"></span>
                                        {followupQuestion}
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    {!this.state.contextCleared && (
                        <div className="input-container">
                            <input
                                type="text"
                                placeholder="Type your message..."
                                value={this.state.inputText}
                                onChange={this.handleInputChange}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.handleSubmit();
                                    }
                                }}
                            />
                            <button onClick={this.handleSubmit}
                                disabled={!this.state.inputText}
                                className={!this.state.inputText ? 'ai-disabled-button' : ''}>
                                <span className="glyphicon glyphicon-send"></span>
                            </button>
                        </div>
                    )}
                    <div className="disclaimer-message">
                        <span>Upland AI Disclaimer:</span>
                        AI responses can be inaccurate. Consider checking important information.
                        <p>
                            By accessing the functionality, you agree to the
                            <a target="_blank" href={this.getLinkedTermsUrl()}>linked terms.</a>
                        </p>
                    </div>
                </div>
            )
        );
    }
});
